import { Loader2, Mic } from "lucide-react";
import { cn } from "../../lib/utils";

const FIELD = "w-full rounded-2xl bg-background px-4 text-base shadow-neu-in text-foreground placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-ring sm:text-sm";

// حقل ثنائي اللغة (عربي + إنجليزي) مع ميكروفون للإملاء ومؤشر ترجمة.
export const TaskBilingualField = ({ base, label, values, onChange, dictate, listening, translating, multiline, placeholder }) => {
  const render = (lng) => {
    const key = `${base}_${lng}`;
    const common = {
      "data-testid": `task-${key}`,
      value: values[key] || "",
      onChange: (e) => onChange(key, e.target.value),
      dir: lng === "ar" ? "rtl" : "ltr",
      placeholder: placeholder?.[lng],
    };
    return (
      <div key={key} dir={lng === "ar" ? "rtl" : "ltr"} className="relative grid min-w-0 gap-1.5">
        <span className="flex items-center justify-between text-sm font-black text-muted-foreground sm:text-xs">
          <span>{label} · {lng.toUpperCase()}</span>
          {translating === key ? <Loader2 className="h-4 w-4 animate-spin text-primary" /> : null}
        </span>
        {multiline
          ? <textarea {...common} rows={3} className={cn(FIELD, "min-h-[84px] resize-none py-3 pe-12")} />
          : <input {...common} className={cn(FIELD, "h-12 leading-none pe-12")} />}
        {dictate ? (
          <button type="button" data-testid={`task-mic-${key}`} title="Voice" onClick={() => dictate(key, lng)}
            className={cn("absolute end-2 bottom-2 grid h-9 w-9 place-items-center rounded-xl bg-background shadow-neu-sm transition-colors active:shadow-neu-in",
              listening === key ? "animate-pulse bg-destructive text-white" : "text-primary")}>
            <Mic className="h-4 w-4" />
          </button>
        ) : null}
      </div>
    );
  };
  return <div className="grid min-w-0 gap-2 sm:col-span-2 sm:grid-cols-2">{["ar", "en"].map(render)}</div>;
};
